import { useSiteInfo } from '../../SiteInfo';

/**
 * Access and update the currency selected in the regional settings. The choice
 * is held in the SiteInfo provider (and persisted in a cookie); the list of
 * offered currencies comes from the site settings. `usePrice` reads the same
 * selected currency to convert and format prices.
 */
export const useSelectedCurrency = () => {
  const {
    selectedCurrency,
    setSelectedCurrency,
    settings: { outputCurrencies },
  } = useSiteInfo();

  return {
    selectedCurrency,
    setSelectedCurrency,
    currencies: outputCurrencies,
  };
};
